<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }
    a {
        text-decoration: unset;
    }
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        font-family: 'Microsoft Yahei', Arial, sans-serif;
        font-size: 14px;
    }
</style>
<style lang="scss">
  //@import './assets/css/common.scss'; //自定义样式
</style>



// WEBPACK FOOTER //
// src/App.vue